import { Building2 } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function CampaignNode({ data, selected }: Props) {
  return (
    <NodeShell
      node={data}
      icon={Building2}
      selected={selected}
      showVersionChip={false}
      hideHandles
    />
  );
}
